import { HTTP, ENDPOINT } from "../config";
import { fetchFromLawfeed } from "../fetchFromLawfeed";

// Actualizar un cliente
export const updateClient = async (clientId, updatedData, organization = null) => {
    const queryParams = organization ? [{ org: organization }] : [];

    return await fetchFromLawfeed({
        method: HTTP.PUT,
        endpoint: ENDPOINT.UPDATE_CLIENT.replace(":client", clientId),
        body: updatedData,
        queryParams: queryParams
    });
};